import {questionTypes} from "../config/constants";

export const getSelectedCode = (question, answers) => {
    let studentAnswers = getQuestionAnswers(question, answers);
    const selectedCode = studentAnswers.filter(
        studentAnswer => studentAnswer.isSelected === true
    ).map(studentAnswer => studentAnswer.answerCode);

    return selectedCode;
};

export const getQuestionAnswers = (question, answers) => {
    //Phải tạo mới vì state không cho cập nhật
    const studentAnswers = answers.filter(answer => answer.questionCode === question.questionCode);
    if (studentAnswers.length === 0) {
        question.answers.forEach(answer => {
            studentAnswers.push({
                    questionCode: question.questionCode,
                    answerCode: answer.answerCode,
                    isSelected: false
                }
            )
        })
    }
    return studentAnswers;
};

export const getNewSelectedAnswers = (question, selectedCode, oldSelectedAnswers, text) => {
    let newSelectedAnswers = [];
    switch (question.questionType) {
        case questionTypes.MULTIPLE_CHOICE:
            oldSelectedAnswers.forEach(oldSelectedAnswer => {
                newSelectedAnswers.push({
                    questionCode: oldSelectedAnswer.questionCode,
                    answerCode: oldSelectedAnswer.answerCode,
                    isSelected: oldSelectedAnswer.answerCode === selectedCode,
                    text: text
                });
            });
            break;
        case questionTypes.COMBO_BOX:
            oldSelectedAnswers.forEach(oldSelectedAnswer => {
                newSelectedAnswers.push({
                    questionCode: oldSelectedAnswer.questionCode,
                    answerCode: oldSelectedAnswer.answerCode,
                    isSelected: (oldSelectedAnswer.answerCode === selectedCode) ? !oldSelectedAnswer.isSelected : oldSelectedAnswer.isSelected,
                    text: text
                });
            });
            break;
        case questionTypes.TEXT_INPUT:
            //Trả về 1 phần tử đầu tiên
            newSelectedAnswers.push({
                questionCode: question.questionCode,
                answerCode: "TL" + question.questionCode,
                isSelected: true,
                text: text
            });
            break;
        default:
            break;
    }
    return newSelectedAnswers;
};
